module.exports = __webpack_public_path__ + "b23c5010385e38052ae078d507c28e40.png";


//////////////////
// WEBPACK FOOTER
// ./assets/images/patches/body/heart-skirt-s.png
// module id = 1287
// module chunks = 0